<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="page-title-section">
    <h2>Assurance Retraite Complémentaire Entreprise</h2>
  </div>

  <div class="main-content">
    <p>
      Si vous êtes à la recherche de ce type d'assurance <span class="highlight">Retraite Complémentaire Entreprise</span>, merci de prendre contact avec nous car il existe trop de déclinaisons selon votre situation personnelle.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <span class="highlight">GENERALI, SWISSLIFE, ALPTIS, MALAKOFF HUMANIS...</span>
    </p>
  </div>

<div class="contact-button-wrapper">
  <button class="btn-contact" (click)="navigateToContact()">Contactez-nous</button>
</div>
</app-page-layout>
